var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8386 1.15965C21.1792 1.51082 21.4212 1.94565 21.54 2.42024C21.8572 4.17894 22.0112 5.9632 22 7.75024C22.0063 9.51058 21.8523 11.2678 21.54 13.0002C21.4212 13.4748 21.1792 13.9097 20.8386 14.2608C20.498 14.612 20.0707 14.8671 19.6 15.0002C17.88 15.4602 11 15.4602 11 15.4602C11 15.4602 4.11996 15.4602 2.39996 15.0002C1.93878 14.8741 1.51794 14.6311 1.17811 14.2947C0.838268 13.9584 0.590921 13.5401 0.459961 13.0802C0.142729 11.3215 -0.0112594 9.53729 -3.87262e-05 7.75024C-0.0088028 5.97655 0.145176 4.2058 0.459961 2.46024C0.57875 1.98565 0.820677 1.55082 1.16131 1.19965C1.50194 0.848485 1.92921 0.593429 2.39996 0.460244C4.11996 0.000244141 11 0.000244141 11 0.000244141C11 0.000244141 17.88 0.000244141 19.6 0.420244C20.0707 0.553429 20.498 0.808485 20.8386 1.15965ZM14.5 7.75023L8.75 11.0202V4.48022L14.5 7.75023Z",
    fill: "#FFC794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a782d9bb83e127b6920580e29087982e.svg";
export { ForwardRef as ReactComponent };